// @flow

import React from 'react';
import logo from './assets/tv-logo.png';
import Styles from './styles';

export default () => (
  <Styles>
    <img src={logo} alt="logo" />
    <h3>
      آپارات تی وی در موبایل و تبلت قابل مشاهده نیست!
    </h3>
    <a
      href="https://www.aparat.com/app"
      target="_blank"
      rel="noopener noreferrer"
      className="appsLink"
    >
      <p>اپلیکیشن آپارات</p>
      <i className="fa fa-android" />
      <i className="fa fa-apple" />
    </a>
  </Styles>
);
